import {
  ContactsImportFileDataBackendType,
  ContactsImportFileDataFrontendType,
} from 'modules/contacts/contacts-import/types/contacts-import-file-interface'
import { isValidEmail } from 'shared/utils/email-validation'

export const transformContactsImportFileDataForFrontend = async ({
  dataFromBackend,
}: {
  dataFromBackend: ContactsImportFileDataBackendType
}) => {
  const fileHasHeaders = !dataFromBackend[0].some(cell => isValidEmail(cell))
  const headers = fileHasHeaders
    ? dataFromBackend[0]
    : new Array(dataFromBackend[0].length).fill(undefined).map((_, index) => String(index + 1))
  const data = dataFromBackend.slice(fileHasHeaders ? 1 : 0)

  const dataForFrontend = {
    items: data.map(row =>
      row.reduce(
        (rowObj, cellValue, cellIndex) => ({
          ...rowObj,
          [headers[cellIndex] ?? String(cellIndex)]: cellValue,
        }),
        {} as ContactsImportFileDataFrontendType[0],
      ),
    ),
    hasMore: false,
  }
  return { dataForFrontend, headers, fileHasHeaders }
}
